module.exports = __webpack_public_path__ + "img/paris-saint-germain.48d9ff9f.png";